import { PromptType } from '../../types/backend';
import type { PromptTypeType, SkillApplicabilityType } from '../../types/backend';

export const PROMPT_TYPE_LABELS: Record<PromptTypeType, string> = {
  playbook: 'Playbook',
  system_prompt: 'System Prompt',
  automation_prompt: 'Automation Prompt',
  skill: 'Skill',
  learned_skill: 'Learned Skill',
  enrichment: 'Enrichment',
  report: 'Report',
};

// Types a user can author in the prompt manager. Excludes only learned_skill
// (auto-synthesized). Enrichment is authorable so operators can assign a custom
// enrichment prompt to a rule's enrichment_prompt_id.
export const CREATABLE_PROMPT_TYPES: readonly PromptTypeType[] = [
  PromptType.PLAYBOOK,
  PromptType.SYSTEM_PROMPT,
  PromptType.AUTOMATION_PROMPT,
  PromptType.SKILL,
  PromptType.ENRICHMENT,
  PromptType.REPORT,
];

// Which agents a skill applies to, by invocation shape (ADR-0064 decision 4).
export const SKILL_APPLICABILITY_LABELS: Record<SkillApplicabilityType, string> = {
  interactive: 'Chat agents',
  batch: 'Background agents',
  both: 'Both',
};

export function promptTypeLabel(type: PromptTypeType): string {
  return PROMPT_TYPE_LABELS[type] ?? type;
}
